/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Delete_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Delete selected commit" |
*
* @param {Snapshot_History_Delete_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_delete_aria_label = /** @type {((inputs?: Snapshot_History_Delete_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Delete_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le commit selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählten Commit löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina il commit selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранный коммит")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar la confirmación seleccionada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除选定的提交")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したコミットを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित कमिट को हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir confirmação selecionada")
	return /** @type {LocalizedString} */ ("Delete selected commit")
});